/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryResponse,
  GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentagePathParams,
  GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage401,
  GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage.ts";

function getGetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageUrl(
  scholarshipTypeId: GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentagePathParams["scholarshipTypeId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/editors/scholarship-types/${scholarshipTypeId}/percentage` as const,
  };
  return res;
}

/**
 * @description Migrado do legado ScholarshipType/GetPercentageValue. **(Requer Authorization para autenticação)**
 * @summary Percentual da bolsa (apenas quando tem valor fixo) (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/editors/scholarship-types/:scholarshipTypeId/percentage}
 */
export async function getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage(
  scholarshipTypeId: GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentagePathParams["scholarshipTypeId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage401
      | GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageUrl(
      scholarshipTypeId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
